import React,{useState} from "react";
import { Link } from "react-router-dom";

import tueetor from '../assets/images/companies/tueetor.png'
import fytns_group from '../assets/images/companies/fytns_group.png'
import zipprosystem from '../assets/images/companies/zipprosystem.png'
import m5azn from '../assets/images/companies/m5azn.jpg'
import opencircleyoga from '../assets/images/companies/opencircleyoga.jpg'
import sunspinmedia from '../assets/images/companies/sunspinmedia.png'
import resident_eservices from '../assets/images/companies/resident_eservices.png'
import manageyourbiz from '../assets/images/companies/manageyourbiz.png'
import halalyouth from '../assets/images/companies/halalyouth.png'
import dhaislamabad from '../assets/images/companies/dhaislamabad.png'
import wnymedical from '../assets/images/companies/wnymedical.png'
import tricktodo from '../assets/images/companies/tricktodo.png'
import askarihousing from '../assets/images/companies/askarihousing.png'
import easternfrontier from '../assets/images/companies/easternfrontier.png'

import Lightbox from 'react-18-image-lightbox';
import "react-18-image-lightbox/style.css"

import {FiCamera} from "../assets/icons/vander"

export default function WorkWith({containerFuild}){
    
    const images = [tueetor, fytns_group, zipprosystem,sunspinmedia, resident_eservices, manageyourbiz, halalyouth, dhaislamabad, wnymedical, tricktodo, askarihousing,easternfrontier]

    const [selectedCategory, setSelectedCategory] = useState(null);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [isOpen, setisOpen] = useState(false);

    const handleMovePrev = () => {
        setCurrentImageIndex((prevIndex) => (prevIndex + images.length - 1) % images.length);
    };

    const handleMoveNext = () => {
        setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    };
    const handleImageClick = (index) => {
        setCurrentImageIndex(index);
        setisOpen(true);
    };
    const currentImage = images[currentImageIndex];

    const projectData = [
        {
            id:0,
            image:tueetor,
            title:"Tueetor",
            description:"Singapore"
        },       
        
        {
            id:12,
            image:m5azn,
            title:"M5AZN",
            description:"Saudi Arabia, KSA"
        },   
        {
            id:2,
            image:sunspinmedia,
            title:"SunSpin Media",
            description:"Buffalo, New York"
        },          
        {
            id:13,
            image:opencircleyoga,
            title:"Open Circle Yoga",
            description:"United Arab Emirates"
        },
        {
            id:3,
            image:zipprosystem,
            title:"ZipproSystem",
            description:"Cambridgeshire, UK"
        },
        {
            id:4,
            image:resident_eservices,
            title:"Resident E-services",
            description:"United Arab Emirates"
        },
        {
            id:5,
            image:manageyourbiz,
            title:"Manage Your Business",
            description:"Williamsville, NY"
        },
        {
            id:6,
            image:wnymedical,
            title:"WNY MEDICAL, PC",
            description:"Amherst, New York"
        },
        {
            id:7,
            image:halalyouth,
            title:"Halal Youth",
            description:"Pakistan"
        },
        {
            id:8,
            image:askarihousing,
            title:"Askari Housing",
            description:"Rawalpindi Pakistan"
        },
        {
            id:9,
            image:dhaislamabad,
            title:"Defence Housing Authority",
            description:"Islamabad, Pakistan"
        },
        
        {
            id:10,
            image:tricktodo,
            title:"Trick ToDo",
            description:"United Kingdom"
        },
        {
            id:1,
            image:fytns_group,
            title:"Fytns Group",
            description:"San Franciso, US"
        },
        {
            id:11,
            image:easternfrontier,
            title:"Eastern Frontier",
            description:"Williamsville, NY"
        },
    ]
    const matchCategory = (category) => {
        setSelectedCategory(category);
    };
    const filteredData = selectedCategory
    ? projectData.filter((item) => item.category === selectedCategory)
    : projectData;
    return(
        <>
         <div className="relative md:mt-24 mt-16">
                <div className="grid grid-cols-1 pb-6 text-center">
                    <h3 className="mb-6 md:text-2xl text-xl font-medium">My Collaborations</h3>

                    <p className="text-slate-400 dark:text-white/60 max-w-xl mx-auto">I'm proud to have collaborated with some awesome companies worldwide.

                    </p>
                </div>

               

              {containerFuild ? 
                <div className="container-fluid relative">
                    <div id="grid" className="grid lg:grid-cols-6 md:grid-cols-4 grid-cols-2 mt-4 gap-[30px] lg:px-6 px-4">
                    {filteredData.map((item,index)=>{
                        return(
                        <div>
                            <div className="picture-item p-1" data-groups='["branding"]' key={index}>
                                <div className="group relative block overflow-hidden rounded-xl duration-500">
                                    <Link to=""   className="lightbox duration-500 group-hover:scale-105" title="">
                                        <img src={item.image} className="" alt=""/>
                                    </Link>
                                    <div className="absolute -bottom-52 group-hover:bottom-2 start-2 end-2 duration-500 bg-white dark:bg-slate-900 p-4 rounded-xl shadow dark:shadow-gray-800">
                                        <Link className="hover:text-orange-500 text-[15px] duration-500 font-medium">{item.title}</Link>
                                        <h6 className="text-slate-400 dark:text-white/60">{item.description}</h6>
                                    </div>
                                </div>
                            </div>
                        </div>
 
                        )
                    })}
                        {isOpen && (
                                    <Lightbox
                                        mainSrc={currentImage}
                                        prevSrc={images[(currentImageIndex + images.length - 1) % images.length]}
                                        nextSrc={images[(currentImageIndex + 1) % images.length]}

                                        onCloseRequest={() => setisOpen(false)}
                                        onMovePrevRequest={handleMovePrev}
                                        onMoveNextRequest={handleMoveNext}
                                    />
                                )}
                    </div>
                </div> :
                <div className="container relative">
                    <div id="grid" className="grid lg:grid-cols-4 md:grid-cols-3 grid-cols-1 mt-4 gap-[30px]">
                    {filteredData.map((item,index)=>{
                        return(
                        <div className="" data-groups='["branding"]' key={index}>
                            <div className="group relative block rounded-xl duration-700 ease-in-out">
                                <div className="relative overflow-hidden rounded-xl">
                                    <Link to="" onClick={() => handleImageClick(item.id)} className="lightbox" title="">
                                        <img src={item.image} className="rounded-xl" alt=""/>
                                    </Link>
                                </div>
                                <div className="content duration-700 ease-in-out">
                                    <div className="bg-white dark:bg-slate-900 p-4 rounded-xl absolute z-10 bottom-3 start-3 duration-700 ease-in-out scale-0 group-hover:scale-100">
                                        <Link to="/portfolio-detail-three" className="h6 text-[15px] font-medium hover:text-orange-500 duration-500 ease-in-out">Mockup Collection</Link>
                                        <p className="text-slate-400 dark:text-white/60 mb-0">Abstract</p>
                                    </div>
                                </div>

                                <div className="absolute inset-0 bg-orange-500 rounded-xl group-hover:-mt-[10px] group-hover:-ms-[10px] h-[98%] w-[98%] duration-700 -z-1"></div>
                            </div>
                        </div>
                        )
                    })}
                        {isOpen && (
                                    <Lightbox
                                        mainSrc={currentImage}
                                        prevSrc={images[(currentImageIndex + images.length - 1) % images.length]}
                                        nextSrc={images[(currentImageIndex + 1) % images.length]}

                                        onCloseRequest={() => setisOpen(false)}
                                        onMovePrevRequest={handleMovePrev}
                                        onMoveNextRequest={handleMoveNext}
                                    />
                                )}
                    </div>
                </div>
              }
            </div>
        </>
    )
}